module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayriskshowers-5bc76e0d9d23bdffecac16fd9a7c9426.svg";